<template>
    <div class="analytics-time-practice-mode">
        <span class="analytics-time-practice-mode__art"></span>
        <div class="analytics-time-practice-mode__total">
            <div class="analytics-time-practice-mode__wr-total">
                <span class="analytics-time-practice-mode__total-icon"></span>
                <div class="analytics-time-practice-mode__wr-total-text">
                    <div
                        v-if="showPreloader"
                        class="analytics-time-practice-mode__total-preloader"></div>
                    <template v-if="!showPreloader">
                        <span class="analytics-time-practice-mode__total-value">
                            <span class="analytics-time-practice-mode__total-value-hours">{{ filteredTimePracticeModeData.total.hours }} sa.</span>
                            <span class="analytics-time-practice-mode__total-value-mins">{{ filteredTimePracticeModeData.total.mins }} dk.</span>
                        </span>
                        <span class="analytics-time-practice-mode__total-label">toplam</span>
                    </template>
                </div>
            </div>
        </div>

        <div class="analytics-time-practice-mode__wr-modes">
            <div class="analytics-time-practice-mode__phonemic-vowel">
                <div class="analytics-time-practice-mode__wr-phonemic-vowel">
                    <div
                        v-if="showPreloader"
                        class="analytics-time-practice-mode__phonemic-vowel-preloader"></div>
                    <template v-if="!showPreloader">
                        <span class="analytics-time-practice-mode__phonemic-vowel-value-hours">{{ filteredTimePracticeModeData.phonemicVowel.hours }} saat</span>
                        <span class="analytics-time-practice-mode__phonemic-vowel-value-mins">{{ filteredTimePracticeModeData.phonemicVowel.mins }} dakika</span>
                        <span class="analytics-time-practice-mode__phonemic-vowel-label">ünlü özellikleri</span>
                    </template>
                    <span class="analytics-time-practice-mode__phonemic-vowel-icon"></span>
                </div>
            </div>

            <div class="analytics-time-practice-mode__phonemic-consonant">
                <div class="analytics-time-practice-mode__wr-phonemic-consonant">
                    <div
                        v-if="showPreloader"
                        class="analytics-time-practice-mode__phonemic-consonant-preloader"></div>
                    <template v-if="!showPreloader">
                        <span class="analytics-time-practice-mode__phonemic-consonant-value-hours">{{ filteredTimePracticeModeData.phonemicConsonant.hours }} saat</span>
                        <span class="analytics-time-practice-mode__phonemic-consonant-value-mins">{{ filteredTimePracticeModeData.phonemicConsonant.mins }} dakika</span>
                        <span class="analytics-time-practice-mode__phonemic-consonant-label">ünsüz özellikleri</span>
                    </template>
                    <span class="analytics-time-practice-mode__phonemic-consonant-icon"></span>
                </div>
            </div>

            <div class="analytics-time-practice-mode__phonetic-vowel">
                <div class="analytics-time-practice-mode__wr-phonetic-vowel">
                    <div
                        v-if="showPreloader"
                        class="analytics-time-practice-mode__phonetic-vowel-preloader"></div>
                    <template v-if="!showPreloader">
                        <span class="analytics-time-practice-mode__phonetic-vowel-value-hours">{{ filteredTimePracticeModeData.phoneticVowel.hours }} saat</span>
                        <span class="analytics-time-practice-mode__phonetic-vowel-value-mins">{{ filteredTimePracticeModeData.phoneticVowel.mins }} dakika</span>
                        <span class="analytics-time-practice-mode__phonetic-vowel-label">ünlü değişkeleri</span>
                    </template>
                    <span class="analytics-time-practice-mode__phonetic-vowel-icon"></span>
                </div>
            </div>

            <div class="analytics-time-practice-mode__phonetic-consonant">
                <div class="analytics-time-practice-mode__wr-phonetic-consonant">
                    <div
                        v-if="showPreloader"
                        class="analytics-time-practice-mode__phonetic-consonant-preloader"></div>
                    <template v-if="!showPreloader">
                        <span class="analytics-time-practice-mode__phonetic-consonant-value-hours">{{ filteredTimePracticeModeData.phoneticConsonant.hours }} saat</span>
                        <span class="analytics-time-practice-mode__phonetic-consonant-value-mins">{{ filteredTimePracticeModeData.phoneticConsonant.mins }} dakika</span>
                        <span class="analytics-time-practice-mode__phonetic-consonant-label">ünsüz değişkeleri</span>
                    </template>
                    <span class="analytics-time-practice-mode__phonetic-consonant-icon"></span>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        data(){
            return {
                showPreloader: true,
            };
        },

        computed: {
            filteredTimePracticeModeData(){
                let selectedFiltertagType = this.$store.state.selectedFiltertag.analyticsPractice.timePracticeMode.type;
                return this.$store.state.response.analyticsPractice.timePracticeModeData[selectedFiltertagType];
            },
        },

        mounted(){
            if(this.$store.state.envDev){
                this.showPreloader = true;
                fetch(this.$store.state.jsonServer.analyticsTimePracticeMode)
                .then(response => response.json())
                .then(timePracticeModeData => {
                    this.$store.commit('setResponse', {
                        categoryLabel: 'analyticsPractice',
                        dataLabel: 'timePracticeModeData',
                        data: timePracticeModeData
                    });
                    this.showPreloader = false;
                });
            }
            else{
                this.showPreloader = true;
                fetch(this.$store.state.api.analyticsPracticeTimePracticeMode, {
                    method: 'GET',
                    credentials: 'include'
                })
                .then(async response => {
                    if(response.status !== 200){
                        throw await response.json();
                    }
                    return response.json();
                })
                .then(timePracticeModeData => {
                    this.$store.commit('setResponse', {
                        categoryLabel: 'analyticsPractice',
                        dataLabel: 'timePracticeModeData',
                        data: timePracticeModeData
                    });
                    this.showPreloader = false;
                })
                .catch(err =>  {
                    this.$foneturkError({
                        text: 'Bir şeyler ters gitti.'
                    });
                    console.error(err);
                });
            }
        }
    };
</script>
<style scoped src="@/css/components/analytics-time-practice-mode.css"></style>